import { useState, useEffect } from "react";
import { useUrlParams } from "./use-url-params";
import { useUrlSetter } from "./use-url-sync";

export const usePageUrl = () => {
  const { getParam, setParam, removeParam } = useUrlParams();

  const pageParam = getParam("events_page");

  const [currentPage, setCurrentPage] = useState<number>(() => {
    return parseInt(pageParam ?? "1", 10);
  });

  useEffect(() => {
    const pageFromUrl = parseInt(pageParam ?? "1", 10);
    if (pageFromUrl !== currentPage) {
      setCurrentPage(pageFromUrl);
    }
  }, [pageParam, currentPage]);

  const setPage = useUrlSetter<number>(
    "events_page",
    setParam,
    removeParam,
    (page: number) => String(page),
    (page: number) => page > 1
  );

  const setPageWithState = (page: number) => {
    setCurrentPage(page);
    setPage(page);
  };

  return { currentPage, setPage: setPageWithState };
};
